export const SensitiveSettingsFeatureName = 'Sensitive Settings';
export const FeaturesScreenFeatureName = 'Features Screen';
export const BusinessSettingsFeatureName = 'Business Settings';
export const OnlyFinanceData = 'Only Finance Data';
export const PosConnectivity = 'Pos Connectivity';
export const CustomerPortal = 'CustomerPortal';
export const AgentFeature = 'Agent';
export const AgentConfigurationFeature = 'Agent Configuration';
export const OloFeature = 'Olo';
export const Tokenization = 'Tokenization';
export const NonMemberCommunication = 'NonMemberCommunication';
export const AccessGroup = 'AccessGroup';
export const PhoneInsights = 'PhoneInsights';
export const NonMemberDeal = 'Non Member Deal';
export const DisableReFilteringCommunication = 'Disable ReFilter Communication';
export const ArtificialIntelligence = "Artificial Intelligence";
export const ExternalApp = "External App";
export const Simple = "Simple";
export const App = 'App';
export const Mishloha = 'Mishloha Services';
export const Paypal = 'Paypal Services';
export const SendMemberSms = 'Send Member Sms';
export const MarketingEmails = 'MarketingEmails';
export const SensitiveLegalActions = 'SensitiveLegalActions';
export const GiftLandingPage = 'Gift Landing Page';
export const CustomEmail = 'CustomEmail';
export const Essentials = 'Essentials';
export const AdvancedPush = 'AdvancedPush';
export const SocialConnect = 'SocialConnect';
export const WalletPass = 'Wallet Pass';
export const LookerForEssentials = 'Looker For Essentials';
export const PromoCodeForEssentials = 'PromoCode For Essentials';
export const API_2_8 = 'API_2_8';
export const API_4_0 = 'API_4_0';
export const PayWithBudget = 'Pay With Budget';
export const Discount = 'Discount';
export const ShoppingCartSubmitPurchase = 'Shopping Cart - Submit Purchase';
export const ShoppingCartGetMemberBenefitsAndRedeem = 'Shopping Cart - Get Member Benefits and Redeem';
export const NoPosGift = 'No Pos Gift';
export const LookerScheduler = 'LookerScheduler';
export const DataExport = 'Data Export';
export const LookerAllHistory = 'Looker All History';
export const CustomLookerDashboards = 'Custom Looker Dashboards';
